import { lazy } from 'react';
import { Login } from './auth';
// import Landing from './modules/landing';
import { Home } from './modules/end-user/user';
import Landing from './modules/landing';
import { ChatScreen } from './modules/end-user/chat';
import { LLMModule } from './modules/end-user/llm';
import Settings from './modules/end-user/settings';
import { Automator } from './modules/end-user/automator';
import WorkFlowAutoMator from './modules/end-user/automator/pages/automator-workflow';
import { LLMConfigModule } from './modules/end-user/embedded';
import FolderTableOrDetailsCard from './modules/end-user/knowledge-base/pages/kb-folders/folder-table-details-card';

const GrigoDashboard = lazy(() => import('./modules/end-user/grigo-dashboard'));
const KnowledgeBase = lazy(() => import('./modules/end-user/knowledge-base/pages/index'));
const PlayGround = lazy(() => import('./modules/end-user/playground/pages/index'));
const UsersList = lazy(() => import('./modules/end-user/user/pages/users/index'));
const RolesList = lazy(() => import('./modules/end-user/user/pages/roles'));
const TeamsList = lazy(() => import('./modules/end-user/user/pages/teams'));
const UnAuthorized = lazy(() => import('./auth/pages/authorized'));
const PageNotFound = lazy(() => import('./components/page-not-found'));
const UserProfile = lazy(() => import('./modules/end-user/profiles/pages/user-profile'));
const Budget = lazy(() => import('./modules/end-user/user/pages/budget'));
const SetPassword = lazy(() => import('./modules/end-user/set-password'));
const AgentsPage = lazy(() => import('./modules/end-user/agents/pages'));
// const Dashboard = lazy(() => import('./modules/end-user/dashboard'));
const AdminDashboard = lazy(() => import('./modules/super-admin/dashboard/pages'));
const ChatPiiConfiguration = lazy(() => import('./modules/end-user/chat-pii-configuration'));
const SensitiveList = lazy(
  () => import('./modules/end-user/dashboard/pages/sensitive-list/sensitive-list'),
);
const CreateYourOwnAssistant = lazy(() => import('./modules/end-user/create-your-assistant'));
const AllAssistants = lazy(() => import('./modules/end-user/all-assistants'));
const AssistantDetails = lazy(
  () => import('./modules/end-user/all-assistants/pages/assistant-details'),
);
const Gateway = lazy(() => import('./modules/end-user/gateway'));

const routes = [
  { path: '/', component: Landing },
  { path: '/login', component: Login },
  { path: '/company-signup', component: Login },
  { path: '/users', component: UsersList },
  { path: '/roles', component: RolesList },
  { path: '/teams', component: TeamsList },
  { path: '/chat', component: ChatScreen },
  { path: '/llm', component: LLMModule },
  { path: '/unauthorized', component: UnAuthorized },
  { path: '/user-profile', component: UserProfile },
  { path: '/budget-settings', component: Settings },
  { path: '/pii-configuration', component: ChatPiiConfiguration },
  { path: '/create-budget', component: Budget },
  { path: '/set-password', component: SetPassword },
  { path: '/dashboard', component: GrigoDashboard },
  // { path: '/grigo-dashboard', component: GrigoDashboard },
  { path: '/system-admin', component: AdminDashboard },
  {
    path: '/dashboard/sensitive-list',
    component: SensitiveList,
  },
  {
    path: '/all-assistants/create-own-assistant',
    component: CreateYourOwnAssistant,
  },
  { path: '/all-assistants', component: AllAssistants },
  { path: '/all-assistants/assistant-details', component: AssistantDetails },
  { path: '/gateway', component: Gateway },
  { path: '/playground', component: PlayGround },
  { path: '/automator', component: Automator },
  {
    path: '/automator/workflow/:projectId?/:workflowId?',
    component: WorkFlowAutoMator,
  },
  {
    path: '/knowledge-base',
    component: KnowledgeBase,
  },
  {
    path: '/knowledge-base/:folderName',
    component: FolderTableOrDetailsCard,
  },
  { path: '/embedding', component: LLMConfigModule },
  { path: '/agents', component: AgentsPage },
  { path: '*', component: PageNotFound },
];

const ROUTES_WITHOUT_LAYOUT = new Set([
  '/',
  '/login',
  '/company-signup',
  '/unauthorized',
  '/set-password',
  '*',
]);

export const publicRoutes = routes.filter((route) => ROUTES_WITHOUT_LAYOUT.has(route.path));
export const layoutRoutes = routes.filter((route) => !ROUTES_WITHOUT_LAYOUT.has(route.path));
export { Home };

export default routes;
